const RealestateAPI = {
  asset: {
    list: '/real_estate',
    detail: '/real_estate/:id',
  },
  listing: {
    list: '/real_estate/listings',
    detail: '/real_estate/listings/:id',
    update: '/real_estate/listings/:id',
    create: '/real_estate/listings',
    delete: '/real_estate/listings/bulk_delete',
    reject: '/real_estate/listings/bulk_reject', // TODO: wait BE change endpoint
  },
  attributes: {
    list: 'https://api.onenetwork.vn/api/app/attributes', // update api admin
  },
  history: {
    list: '/real_estate/change_histories',
    create: '/real_estate/change_histories',
    delete: '/real_estate/change_histories/delete',
  },
}
export default RealestateAPI
